import { takeLatest, call, put } from 'redux-saga/effects';

import contactService from 'services/contactService';

import { receiveQuote } from 'store/quotes/actions';
import { getOrCreateQuote } from 'store/quotes/getOrCreateQuote';

import { types, saveAccountNotes, saveContactNotes } from './actions';

export default function* root() {
  yield takeLatest(types.ACCOUNT_NOTES_REQUEST, watchSaveAccountNotes);
  yield takeLatest(types.CONTACT_NOTES_REQUEST, watchSaveContactNotes);
}

function* watchSaveAccountNotes(action) {
  try {
    const { accountId, notes } = action.payload;
    const prevQuote = yield call(getOrCreateQuote);
    const quote = {
      ...prevQuote,
      contact: {
        ...prevQuote.contact,
        account: { ...prevQuote.contact.account, notes },
      },
    };
    yield put(receiveQuote(quote));
    yield call(contactService.accounts.update, accountId, {
      notes,
    });
    yield put(saveAccountNotes.success());
  } catch (error) {
    yield put(saveAccountNotes.error(error.message));
  }
}

function* watchSaveContactNotes(action) {
  try {
    const { contactId, notes } = action.payload;
    const prevQuote = yield call(getOrCreateQuote);
    const quote = { ...prevQuote, contact: { ...prevQuote.contact, notes } };
    yield put(receiveQuote(quote));
    yield call(contactService.contacts.update, contactId, {
      notes,
    });
    yield put(saveContactNotes.success());
  } catch (error) {
    yield put(saveContactNotes.error(error.message));
  }
}
